import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
import ButtonBase from '@mui/material/ButtonBase';
import Box from '@mui/material/Box';

import t from '@localise/translate';

import { Data, Font } from '@hooks/index';
import { Env, Map } from '@functions/index';

import { TextOpenClose } from '@common/TextOpenClose/TextOpenClose';
import { TextWithIcon } from '@common/TextWithIcon/TextWithIcon';

import useMediaQuery from '@mui/material/useMediaQuery';

import styles from './style.scss';

const Menu = [
  {
    label: t('nav.home'),
    pathname: '/',
    sectionName: 'home',
    exact: true,
  },
  {
    label: t('nav.aboutUs'),
    pathname: '/about',
    sectionName: 'about',
  },
  {
    label: t('nav.map'),
    pathname: '/map',
    sectionName: 'map',
  },
  {
    label: t('nav.contact'),
    pathname: '/contact',
    sectionName: 'contact',
  },
];

const Navbar = (): JSX.Element => {
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    setTimeout(() => setIsLoaded(true), 1000);
  }, []);

  // const [selectedIndex, setSelectedIndex] = useState(0);

  // const location = useLocation();
  // const history = useHistory();

  const fontLoaded = Font.useFonts();
  const { unavailability } = Data.usePage();

  /*
  useEffect(() => {
    const index = Menu.findIndex((item) => (item.exact ? location.pathname === item.pathname : location.pathname.startsWith(item.pathname)));

    if (index > -1) {
      setSelectedIndex(index);
    }
  }, [location.pathname]); */

  /*
  const redirect = (event: MouseEvent, path: string) => {
    event.preventDefault();
    history.push(path);
  }; */

  const hasSecondaryStyle = !Env.isHomePage();

  const scrollToSection = (section: string) => {
    const element = document.getElementById(section);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const infoBox = (
    <div className={classNames(styles.block, styles.blockCenter, styles.loading, (isLoaded || unavailability) && styles.loaded)}>
      <TextOpenClose onClick={() => scrollToSection('contact')} unavailability={unavailability} />
      <TextWithIcon icon="place" text={t('client.address')} onClick={() => Map.navigateToClientCompany()} />
    </div>
  );

  const useMobile = useMediaQuery('(max-width: 1280px)');

  return (
    <>
      <nav className={classNames(styles.wrap, hasSecondaryStyle && styles.secondary, !fontLoaded && styles.transparentFont)} id="home">
        <div className={styles.body}>
          <div className={styles.blockStart}>
            <div className={styles.logoWrap}>
              <ButtonBase disableRipple classes={{ root: styles.logoButton }} onClick={() => scrollToSection('home')}>
                <div>
                  <Box display="flex" gap={2}>
                    <span className={styles.logoPrimaryText}>{t('logo.part1')}</span>
                    <span className={styles.logoSecondaryText}>{t('logo.part2')}</span>
                  </Box>
                  <div className={styles.logoDescription}>{t('logo.extraInfo')}</div>
                </div>
              </ButtonBase>
              {/**<img src={logo} alt="we-project-logo" className={styles.logo} /> **/}
            </div>
          </div>
          {!useMobile && infoBox}
          <div className={styles.blockEnd}>
            <ul className={styles.navigation}>
              {Menu.filter((item) => item.pathname !== '/').map((item, index) => (
                <ButtonBase
                  disableRipple
                  component="li"
                  classes={{ root: styles.navItem }}
                  key={index}
                  onClick={() => {
                    // redirect(e, item.pathname);
                    // setSelectedIndex(index);
                    scrollToSection(item.sectionName);
                  }}
                >
                  <span className={classNames(styles.label)}>{item.label}</span>
                </ButtonBase>
              ))}
            </ul>
          </div>
        </div>
        {useMobile && infoBox}
      </nav>
    </>
  );
};

export default Navbar;
